<template>
  <mdb-navbar
    color="black"
    class="lighten-3"
    expand="xl"
    dark
    hamburger
    animated
    animation="3"
  >
    <!-- Navbar brand -->
    <mdb-navbar-brand class="navbar navbar-expand navbar-primary">
      <a class="navbar-brand" href="/landing">Fresh Prep</a></mdb-navbar-brand
    >
    <ul class="navbar-nav navbar-primary">
    </ul>

    <mdb-navbar-toggler>
      <mdb-navbar-nav right>
        <nav
          class="navbar navbar-expand navbar-secondary"
          v-if="isAuthenticated"
        >
          <div class="container-fluid justify-content-center">
            <ul class="navbar-nav">
              <template v-if="isAdmin">
                <li class="nav-item">
                  <router-link to="/scan-history">Scan History</router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/locations">Locations</router-link>
                </li>
                 <li class="nav-item">
                  <router-link to="/asset-states">Asset States</router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/stations">Stations</router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/users">Accounts</router-link>
                </li>
                 <li class="nav-item">
                  <router-link to="/assets">Assets</router-link>
                </li>
              </template>

              <li class="nav-item " v-if="isAuthenticated">
                <span> {{ email }}</span> <br/>
                <span class="logout"><a @click="signOut"><i class="fa fa-power-off"> </i> Logout</a></span>
              </li>
            </ul>
          </div>
        </nav>
      </mdb-navbar-nav>
    </mdb-navbar-toggler>
  </mdb-navbar>

</template>

<script>
import {
  mdbNavbar,
  mdbNavbarNav,
  mdbNavbarToggler,
  mdbNavbarBrand,
} from "mdbvue";
export default {
  name: "AppHeader",
  components: {
    mdbNavbar,
    mdbNavbarNav,
    mdbNavbarToggler,
    mdbNavbarBrand,
  },
  data() {
    return {
      isStationSet: !!this.$store.state.stationInfo,
      stationState: ''
    };
  },

  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    isAdmin() {
      return this.isAuthenticated ? this.$store.getters.isAdmin : false;
    },
    email() {
      return this.$store.state.user.data.email;
    },

    stationInfo() {
      return this.isStationSet
        ? `${this.stationState.toUpperCase()}`
        : "undefined";
    },
  },
  methods: {
    signOut: function() {
      this.$store.dispatch("signOut").then(() => {
        this.$router.push("sign-in");
      });
    },
  },

  mounted() {
    this.stationState = this.$store.state.stationInfo.scan_state;
  }
};
</script>

<style scoped lang="scss">
.nav-item {
  a {
    color: $brand-text-color;
    opacity: 0.7;
    text-decoration: none;
    padding-bottom: 2px;

    &.active,
    &:hover {
      color: $brand-text-color;
      opacity: 1;
    }

    &:hover {
      cursor: pointer;
    }
  }
}

.navbar-primary {
  background-color: $nav-primary-color;

  .nav-item {
    margin-right: 15px;

    a {
      font-size: 1rem;
    }

    &.user {
      color: $muted-text-color;
    }
    span {
      padding-left: 1rem;
    }
  }
}

.muted-text {
  color: $muted-text-color;
}

.logout  {
  font-size: 0.2rem;
}

.navbar-secondary {
  background-color: $nav-secondary-color;
  padding-bottom: 25px;

  .nav-item {
    margin: 0 15px;
    a {
      font-size: 1.2rem;
      padding: 0;
    }
  }

  .badge {
    font-size: 0.85rem;
    font-weight: 400;
    color: $primary-text-color;
    background-color: $green-accent-color;
    vertical-align: top;
    margin-left: 1px;
    font-feature-settings: "tnum";
    font-variant-numeric: tabular-nums;
  }
}

a.router-link-exact-active {
  border-bottom: 2px solid $green-accent-color;
  opacity: 1;
}

.brand {
  // text-align: center;
  background-color: $nav-secondary-color;
  padding: 20px 0 20px 0;

  .logo {
    display: inline-block;
    vertical-align: top;
    margin-right: 12px;
  }

  .name {
    font-size: 2.6rem;
    font-weight: 600;
    text-transform: uppercase;
    display: inline-block;
    color: $brand-text-color;
  }
}
</style>
